import { useAuth } from "@/store/auth";
import { useStation } from "camera/store/station";
import { useCamera } from "camera/store/camera";

export default function useCameraSettingsUpdater(
  stationManager: CameraStationManager
): Optional<CSTypes.SettingsStore, "xmppLogin"> {
  const { device, updateDevice } = useAuth(({ device, updateDevice }) => ({
    device,
    updateDevice
  }));
  const { xmppLogin } = device.xmppCredentials || {};
  const cameraId = useCamera(({ cameraId }) => cameraId);
  const {
    icon,
    color,
    settings,
    updateSettings,
    setColor,
    setIcon,
    supportedFeatures,
    noiseCorrection,
    setNoiseCorrection
  } = useStation(
    ({
      icon,
      color,
      settings,
      updateSettings,
      setColor,
      setIcon,
      supportedFeatures,
      noiseCorrection,
      setNoiseCorrection
    }) => ({
      icon,
      color,
      settings,
      supportedFeatures,
      noiseCorrection,
      updateSettings,
      setNoiseCorrection,
      setColor,
      setIcon
    })
  );
  const { name } = device;

  return {
    xmppLogin,
    hasDetectionZonesSupport: supportedFeatures.includes("SINGLE_MOTION_DETECTION_ZONE"),
    getDetectionZonesPreview: async () => {
      return { preview: { ...(await stationManager.getDetectionZonesPreview()), cameraId: cameraId! } };
    },
    noiseCorrection: {
      get: () => noiseCorrection,
      set: (value: number) => setNoiseCorrection(value)
    },
    state: {
      icon,
      color,
      name,
      settings
    },
    update({ color, name, settings, icon }) {
      if (icon) setIcon(icon);
      if (color) setColor(color);
      if (name) updateDevice({ name });
      if (settings) updateSettings(settings);
    }
  };
}
